var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c("history-dialog", {
        attrs: {
          visible: _vm.historyDialogVisible,
          "employee-id": _vm.currentEmployeeId
        },
        on: {
          "update:visible": function($event) {
            _vm.historyDialogVisible = $event
          }
        }
      }),
      _c(
        "div",
        { staticClass: "title" },
        [
          _c(
            "el-breadcrumb",
            { attrs: { separator: "/" } },
            [
              _c("el-breadcrumb-item", [_vm._v("平台建设")]),
              _c("el-breadcrumb-item", [_vm._v("基础信息")]),
              _c("el-breadcrumb-item", [_vm._v("员工信息")])
            ],
            1
          )
        ],
        1
      ),
      _c("div", { staticClass: "title-en" }, [_vm._v("员工信息（在职）")]),
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c("div", { staticClass: "table-header" }, [
            _c(
              "div",
              [
                _c(
                  "el-radio-group",
                  {
                    staticStyle: { "margin-bottom": "20px" },
                    on: { change: _vm.handleTabChange },
                    model: {
                      value: _vm.tabPosition,
                      callback: function($$v) {
                        _vm.tabPosition = $$v
                      },
                      expression: "tabPosition"
                    }
                  },
                  [
                    _c("el-radio-button", { attrs: { label: "在职" } }, [
                      _vm._v("在职")
                    ]),
                    _c("el-radio-button", { attrs: { label: "离职" } }, [
                      _vm._v("离职")
                    ])
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              [
                _c(
                  "el-button",
                  {
                    attrs: {
                      type: "primary",
                      size: "small",
                      disabled: !_vm.canEdit
                    },
                    on: { click: _vm.handleAdd }
                  },
                  [_vm._v("添加")]
                )
              ],
              1
            )
          ]),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading"
                }
              ],
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.tableData,
                "header-cell-style": _vm.headerStyle,
                "row-class-name": _vm.tableRowClassName
              }
            },
            [
              _c("el-table-column", {
                attrs: {
                  label: "序号1",
                  align: "center",
                  type: "index",
                  width: "80"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "name",
                  label: "姓名",
                  align: "center",
                  width: "120"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("span", [_vm._v(_vm._s(scope.row.name || "-"))])
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "gender",
                  label: "性别",
                  align: "center",
                  width: "80"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("span", [_vm._v(_vm._s(scope.row.gender || "-"))])
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "birth_year",
                  label: "出生年月",
                  align: "center",
                  width: "120"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("span", [
                          _vm._v(_vm._s(scope.row.birth_year || "-"))
                        ])
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "id_card",
                  label: "身份证",
                  align: "center",
                  width: "180"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("span", [_vm._v(_vm._s(scope.row.id_card || "-"))])
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "phone",
                  label: "电话",
                  align: "center",
                  width: "120"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("span", [_vm._v(_vm._s(scope.row.phone || "-"))])
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "entry_date",
                  label: "入职日期",
                  align: "center",
                  width: "120"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("span", [
                          _vm._v(_vm._s(scope.row.entry_date || "-"))
                        ])
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "leave_date",
                  label: "离职日期",
                  align: "center",
                  width: "120"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("span", [
                          _vm._v(_vm._s(scope.row.leave_date || "-"))
                        ])
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "entry_attr_date",
                  label: "入职属性日期",
                  align: "center",
                  width: "120"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("span", [
                          _vm._v(_vm._s(scope.row.entry_attr_date || "-"))
                        ])
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: { prop: "remark", label: "备注", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("span", [_vm._v(_vm._s(scope.row.remark || "-"))])
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "status",
                  label: "状态",
                  align: "center",
                  width: "80"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("span", [_vm._v(_vm._s(scope.row.status || "-"))])
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: { label: "操作", align: "center", width: "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "el-dropdown",
                          {
                            on: {
                              command: function(command) {
                                return _vm.handleCommand(command, scope.row)
                              }
                            }
                          },
                          [
                            _c("span", { staticClass: "el-dropdown-link" }, [
                              _vm._v("\n              更多操作 "),
                              _c("i", {
                                staticClass: "el-icon-arrow-down el-icon--right"
                              })
                            ]),
                            _c(
                              "el-dropdown-menu",
                              { attrs: { slot: "dropdown" }, slot: "dropdown" },
                              [
                                _c(
                                  "el-dropdown-item",
                                  {
                                    attrs: {
                                      command: "edit",
                                      disabled: !_vm.canEdit
                                    }
                                  },
                                  [_vm._v("编辑")]
                                ),
                                _c(
                                  "el-dropdown-item",
                                  {
                                    attrs: {
                                      command: "delete",
                                      disabled:
                                        !_vm.isAuthorizedUser() ||
                                        scope.row.status !== "离职" ||
                                        !_vm.canEdit
                                    }
                                  },
                                  [_vm._v("删除")]
                                ),
                                _c(
                                  "el-dropdown-item",
                                  { attrs: { command: "history" } },
                                  [_vm._v("历史记录")]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "pagination-container" },
            [
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.pageParams.skip,
                  "page-sizes": [10, 20, 50, 100],
                  "page-size": _vm.pageParams.limit,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.total
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-drawer",
        {
          attrs: {
            title: _vm.drawerTitle,
            visible: _vm.drawerVisible,
            direction: "rtl",
            size: "30%",
            "before-close": _vm.handleClose
          },
          on: {
            "update:visible": function($event) {
              _vm.drawerVisible = $event
            }
          }
        },
        [
          _c(
            "div",
            [
              _c(
                "el-form",
                {
                  ref: "employeeForm",
                  attrs: {
                    model: _vm.formData,
                    rules: _vm.rules,
                    "label-width": "130px",
                    "label-position": "right"
                  }
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "姓名", prop: "name" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入姓名" },
                        model: {
                          value: _vm.formData.name,
                          callback: function($$v) {
                            _vm.$set(_vm.formData, "name", $$v)
                          },
                          expression: "formData.name"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "性别", prop: "gender" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { placeholder: "请选择性别" },
                          model: {
                            value: _vm.formData.gender,
                            callback: function($$v) {
                              _vm.$set(_vm.formData, "gender", $$v)
                            },
                            expression: "formData.gender"
                          }
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "男", value: "男" }
                          }),
                          _c("el-option", {
                            attrs: { label: "女", value: "女" }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "出生年月", prop: "birth_year" } },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          type: "month",
                          placeholder: "选择月份",
                          "value-format": "yyyy-MM"
                        },
                        model: {
                          value: _vm.formData.birth_year,
                          callback: function($$v) {
                            _vm.$set(_vm.formData, "birth_year", $$v)
                          },
                          expression: "formData.birth_year"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "身份证", prop: "id_card" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入身份证号码" },
                        model: {
                          value: _vm.formData.id_card,
                          callback: function($$v) {
                            _vm.$set(_vm.formData, "id_card", $$v)
                          },
                          expression: "formData.id_card"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "电话", prop: "phone" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入电话号码" },
                        model: {
                          value: _vm.formData.phone,
                          callback: function($$v) {
                            _vm.$set(_vm.formData, "phone", $$v)
                          },
                          expression: "formData.phone"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "入职日期", prop: "entry_date" } },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          type: "date",
                          placeholder: "选择日期",
                          "value-format": "yyyy-MM-dd"
                        },
                        model: {
                          value: _vm.formData.entry_date,
                          callback: function($$v) {
                            _vm.$set(_vm.formData, "entry_date", $$v)
                          },
                          expression: "formData.entry_date"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "离职日期" } },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          type: "date",
                          placeholder: "选择日期",
                          "value-format": "yyyy-MM-dd"
                        },
                        model: {
                          value: _vm.formData.leave_date,
                          callback: function($$v) {
                            _vm.$set(_vm.formData, "leave_date", $$v)
                          },
                          expression: "formData.leave_date"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: "入职属性日期", prop: "entry_attr_date" }
                    },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          type: "date",
                          placeholder: "选择日期",
                          "value-format": "yyyy-MM-dd"
                        },
                        model: {
                          value: _vm.formData.entry_attr_date,
                          callback: function($$v) {
                            _vm.$set(_vm.formData, "entry_attr_date", $$v)
                          },
                          expression: "formData.entry_attr_date"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "备注" } },
                    [
                      _c("el-input", {
                        attrs: { type: "textarea", placeholder: "请输入备注" },
                        model: {
                          value: _vm.formData.remark,
                          callback: function($$v) {
                            _vm.$set(_vm.formData, "remark", $$v)
                          },
                          expression: "formData.remark"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "状态" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { placeholder: "请选择状态" },
                          model: {
                            value: _vm.formData.status,
                            callback: function($$v) {
                              _vm.$set(_vm.formData, "status", $$v)
                            },
                            expression: "formData.status"
                          }
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "在职", value: "在职" }
                          }),
                          _c("el-option", {
                            attrs: { label: "离职", value: "离职" }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.handleSubmit }
                        },
                        [_vm._v("确定")]
                      ),
                      _c("el-button", { on: { click: _vm.handleClose } }, [
                        _vm._v("取消")
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }